// extracted by mini-css-extract-plugin
module.exports = {"label":"talent-finder-pagination_label__1BnA4"};